<!--The content below is only a placeholder and can be replaced.-->
<div class="content">
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</div>
